export default __webpack_public_path__ + "static/media/Rejuvinating Shoulders.a2520902.jpg";